import Box from "@/components/Box";
import { InternalTextLink } from "@/components/Links";
import { theme } from "@/core/theme";
import Asterisk from "@/tpo/Asterisk";
import { PanelBoxV2 } from "@/tpo/Boxes";
import ChevronComponent from "@/tpo/Chevron";
import ControlledFormField from "@/tpo/ControlledFormField";
import FloatingLabelInput from "@/tpo/FloatingLabelInput";
import LinkWrapper from "@/tpo/LinkWrapper";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

export default function YourDetailsSection({ children, fieldNames = {} }) {
  return (
    <PanelBoxV2
      maxWidth={1532}
      outer={{
        pt: theme.spacing.section.pt,
        pb: theme.spacing.section.pb,
        px: [20],
        bg: "haze",
        "data-component-name": "YourDetailsSection"
      }}
    >
      <PanelBoxV2 maxWidth={1024}>
        <PanelBoxV2
          maxWidth={720}
          outer={{
            pt: [30, 30, 60],
            pb: [50, 50, 80],
            bg: "white",
            borderRadius: 20,
            px: 20
          }}
          stacked
          gap={[20, 20, 40]}
        >
          <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} lineHeight="130%">
            Your details
            <Asterisk />
          </Box>
          <Stack gap={20}>
            <ControlledFormField
              name={fieldNames["firstName"] || "firstName"}
              label="First name"
              Component={FloatingLabelInput}
            />
            <ControlledFormField
              name={fieldNames["lastName"] || "lastName"}
              label="Last name"
              Component={FloatingLabelInput}
            />
            <ControlledFormField
              name={fieldNames["jobRole"] || "jobRole"}
              label="Role"
              Component={FloatingLabelInput}
            />
            <ControlledFormField
              name={fieldNames["phoneNumber"] || "phoneNumber"}
              label="Contact Number"
              Component={FloatingLabelInput}
            />
          </Stack>
          <Stack gap={20} flexDirection={["column", "row", "row"]} alignItems="flex-start">
            <ButtonV2
              as={LinkWrapper}
              color="dark"
              rightIcon={<ChevronComponent />}
              to="/settings"
              size={["sm", "sm", "md"]}
            >
              edit personal profile
            </ButtonV2>
          </Stack>
        </PanelBoxV2>
        {children}
      </PanelBoxV2>
    </PanelBoxV2>
  );
}
